import React from "react";
import SharedStateContext from "./SharedStateContext";
import Provider from "../Provider";
import { AuthenticationService } from "../../services/logIn/AuthenticationService";
import { handleError } from "../../utils/ErrorHandlers";

export default class SharedStateProvider extends Provider {
  storageKey = "state";
  default_state = {
    is_authenticated: false,
    state_fetched: false,
    session_id: "",
    user: {},
    user_status: "",
    curr_lang: "en",
    curr_dir: "ltr",
    currentComponent: "",
    setCurrentComponent: (key) => this.setCurrentComponent(key),
    updateLangAndDir: (lang, dir) => this.updateLangAndDir(lang, dir),
    updateUserAndSession: (session_id, user) =>
      this.updateUserAndSession(session_id, user),
    updateUser: (user) => this.updateUser(user),
    updateSession: (session_id) => this.updateSession(session_id),
    resetSession: (session_id) => this.resetSession(),
    hasAnyPrivilege: (privileges) => this.hasAnyPrivilege(privileges),
    updateUserStatus: (user_status) => this.updateUserStatus(user_status),
    updateUserImg: (user_img) => this.updateUserImg(user_img),
  };

  state = {
    ...this.default_state,
  };

  constructor(props) {
    super(props);
    this.authenticationService = new AuthenticationService();
  }

  async componentDidMount() {
    try {
      let storedState = JSON.parse(sessionStorage.getItem(this.storageKey));

      await this.setStateAndSave((prev_state) => {
        return {
          ...storedState,
          state_fetched: true,
        };
      });
    } catch (e) {
      this.setStateAndSave((prev_state) => {
        return {
          ...prev_state,
          state_fetched: true,
        };
      });
    }
  }

  updateUserAndSession(session_id, user) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        session_id,
        user,
        is_authenticated: true,
      };
    });
  }
  updateUserStatus(user_status) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        user_status,
        is_authenticated: true,
      };
    });
  }

  updateUserImg(user_img) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        user_img,
        is_authenticated: true,
      };
    });
  }
  updateSession(session_id) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        session_id,
        is_authenticated: true,
      };
    });
  }

  updateDefaultTree(defaultTree) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        defaultTree,
      };
    });
  }

  updateUser(user) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        user,
      };
    });
  }

  async resetSession() {
    try {
      this.authenticationService.logout(this.state.session_id);
      await this.setStateAndSave((prev_state) => {
        return {
          ...this.default_state,
          state_fetched: true,
        };
      });
    } catch (e) {
      handleError(e);
    }
  }

  hasAnyPrivilege(privilegesToCheck = []) {
    let { privilegesList = [] } = this.state.user;
    for (let i = 0; i < privilegesToCheck.length; i++) {
      if (privilegesList.indexOf(privilegesToCheck[i]) >= 0) {
        return true;
      }
    }
    return false;
  }
  updateLangAndDir(lang, dir) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        curr_lang: lang,
        curr_dir: dir,
      };
    });
  }
  setCurrentComponent(key) {
    this.setStateAndSave((prev_state) => {
      return {
        ...prev_state,
        currentComponent: key,
      };
    });
  }

  render() {
    return (
      <SharedStateContext.Provider value={this.state}>
        {this.props.children}
      </SharedStateContext.Provider>
    );
  }
}
